module.exports = __webpack_public_path__ + "static/media/shape_1.cf0a8c0c.svg";